export const addZero = (count) => {
  return count > 9 ? count : `0${count}`;
};
